
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drain-down",
      function () {
        return require("private-next-pages/drain-down/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drain-down"])
      });
    }
  